export default (eventName, detail) => {
  let testEvent = new CustomEvent(`LumenTest-SendData`, {
    detail: { type: eventName, body: detail },
  });
  document.dispatchEvent(testEvent);
};
